// import('./bootstrap');
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import Apps from '@/entries/App';
import '@/styles';

// eslint-disable-next-line @typescript-eslint/init-declarations
let nodeBox: ReactDOM.Root;

const render = (props: any) => {
    const {container = document.body} = props;
    const node = document.createElement('div');
    nodeBox = ReactDOM.createRoot(container.appendChild(node) as HTMLElement);
    nodeBox.render(
        <BrowserRouter basename={window.__POWERED_BY_QIANKUN__ ? '/dep2nd' : '/'}>
            <Apps />
        </BrowserRouter>
    );
};
// eslint-disable-next-line no-underscore-dangle
if (window.__POWERED_BY_QIANKUN__) {
    // eslint-disable-next-line no-underscore-dangle, camelcase
    window.__webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}

// eslint-disable-next-line no-underscore-dangle
if (!window.__POWERED_BY_QIANKUN__) {
    render({});
}

export async function bootstrap() {
    // TODO
}

export async function mount(props: any) {
    console.info(props, 'mount');
    // alert(JSON.stringify(props));
    render(props);
}

export async function unmount(props: any) {
    console.info(props);
    // const {container = document.body} = props;
    // const root = ReactDOM.createRoot(container.querySelector(`#${nodeId}`));
    nodeBox.unmount();
    // unmountComponentAtNode(container.querySelector('#alarm'));
}
